<template>
  <div class="toggle-div" @click="changeShow">
    <template v-if="!isShow">
        <svg aria-hidden="true" class="icon-svg"><use xlink:href="#icon-down"></use></svg>&nbsp;&nbsp;&nbsp;{{ $t('common.openMore') }}
    </template>
    <template v-if="isShow">
        <svg aria-hidden="true" class="icon-svg"><use xlink:href="#icon-up"></use></svg>&nbsp;&nbsp;&nbsp;{{ $t('common.hide') }}
    </template>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isShow: false
    }
  },
  watch: {
  },
  methods: {
    changeShow () {
      this.isShow = !this.isShow
      this.$emit('toggle', this.isShow)
    }
  },
  props: {
  }
}
</script>
<style lang="scss" scoped>
.toggle-div{
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px -20px 0px -20px;
    font-size: 12px;
    border-top: 1px solid #ccc;
    box-shadow: 0px 5px 5px #ccc;
    margin-bottom: 15px;
    cursor: pointer;
}
</style>
